import { type LabelTypeColors } from '@capsicum/common';

export const useSurveyStatusColor = () => {
	const getStatusColors = (status = 'opened') => {
		const getStatusColor = {
			closed: 'red',
			opened: 'green',
			scheduled: 'blue'
		} as { [key: string]: LabelTypeColors };

		return getStatusColor[status];
	};

	return getStatusColors;
};
